import ReactToPrint, { useReactToPrint } from 'react-to-print';
import React, { useRef, useEffect, useState } from 'react';
import HTMLTest from '../../resources/html/ss.txt';
import HTMLPAGE from '../../resources/html/page1t.txt';
import HTMLPAGE_SECOND from '../../resources/html/page2t.txt';
import styled, { css } from 'styled-components';
import {CUSTOM_FONTS} from '../../fonts/font';
import Logo from '../../resources/images/svg/logo.svg'

const ReportBlock = styled.div`
    @page {
        size: A4;
        margin: 16mm;
    }
    
    // 전체적인 폰트 크기 조정
    font-size: 6pt;  // 기본 폰트 크기를 약간 줄임
    
    
    // 페이지 나누기 방지
    .page-break {
        page-break-inside: avoid;
    }
`;

const ReportView = ({
    item
}) => {
    const [htmltext1, setHtmltext1] = useState("")
    const [htmltext2, setHtmltext2] = useState("")
    const [isDataReady, setIsDataReady] = useState(false)

    
    useEffect(() => {
        console.log('item : ', item)
        if(!item)
        {
            return;
        }
        Promise.all([
            fetch(HTMLPAGE).then(r => r.text()),
            fetch(HTMLPAGE_SECOND).then(r => r.text())
        ]).then(([text1, text2]) => {
            setHtmltext1(text1);
            setHtmltext2(text2);
            
            // 주소 텍스트 길이에 따른 폰트 크기 조정 함수
            const adjustFontSize = (element, maxLength = 60) => {
                if (!element) return;
                
                const text = element.innerText;
                if (text.length > maxLength) {
                    // 텍스트 길이에 따라 폰트 크기 동적 조정
                    const fontSize = Math.max(7, 9 - (text.length - maxLength) * 0.1);
                    element.style.fontSize = `${fontSize}pt`;
                } else {
                    element.style.fontSize = '9pt'; // 기본 크기
                }
            };
            
            // setTimeout 대신 requestAnimationFrame 사용
            requestAnimationFrame(() => {
                // 첫 번째 페이지 데이터 설정
                let item_Object1 = document.getElementById("print_item1");
                if (item_Object1) {
                    // ... 기존의 첫 번째 페이지 데이터 설정 코드 ...
                    let name_input = item_Object1.getElementsByClassName('name_input')[0];
                    let jumin_input = item_Object1.getElementsByClassName('jumin_input')[0];
                    let phone_input = item_Object1.getElementsByClassName('phone_input')[0];
                    let address_input = item_Object1.getElementsByClassName('address_input')[0];
                    let address_real_input = item_Object1.getElementsByClassName('address_real_input')[0];
                    let pat_registnumber_input = item_Object1.getElementsByClassName('pat_registnumber_input')[0];
                    let pat_name_input = item_Object1.getElementsByClassName('pat_name_input')[0];
                    let pat_kind_input = item_Object1.getElementsByClassName('pat_kind_input')[0];
                    let pat_color_input = item_Object1.getElementsByClassName('pat_color_input')[0];
                    let pat_sex_input = item_Object1.getElementsByClassName('pat_sex_input')[0];
                    let pat_neutering_input = item_Object1.getElementsByClassName('pat_neutering_input')[0];
                    let pat_birth_input = item_Object1.getElementsByClassName('pat_birth_input')[0];
                    let pat_regist_input = item_Object1.getElementsByClassName('pat_regist_input')[0];
                    let regist_input = item_Object1.getElementsByClassName('regist_input')[0];
                    let sign_name_input = item_Object1.getElementsByClassName('sign_name_input')[0];
                    let sign_image_input = item_Object1.getElementsByClassName('sign_image_input')[0];
                    
                    console.log('item : ', item)

                    // pat_registnumber_input .innerText = 등록 번호 입력;
                    pat_registnumber_input.innerText = item.RFID?item.RFID:"";
                    name_input.innerText = item.name;
                    jumin_input.innerText = `${item.jumin} - ${item.jumin_next}`;
                    phone_input.innerText = item.phone;

                    if(item.addr == item.real_addr && item.addr_next == item.real_addr_next && item.addr_post == item.real_addr_post)
                    {
                        address_input.innerText = `우편번호(${item.addr_post}) ${item.addr} ${item.addr_next}`;
                        address_real_input.innerText = "";
                    }
                    else
                    {
                        address_input.innerText = `주소 - 우편번호(${item.addr_post}) ${item.addr} ${item.addr_next}`;
                        address_real_input.innerText = `현재 거주지 - 우편번호(${item.real_addr_post}) ${item.real_addr} ${item.real_addr_next}`;
                    }

                    // 주소 텍스트 길이에 따라 폰트 크기 조정
                    adjustFontSize(address_input);
                    adjustFontSize(address_real_input);
                    
                    pat_name_input.innerText = item.pat_name;
                    pat_kind_input.innerText = item.pat_kind;
                    pat_color_input.innerText = item.pat_color;
                    pat_sex_input.innerText = item.pat_sex == "1"?'수':'암';
                    pat_neutering_input.innerText = item.pat_neutering == "1"?'여':'부';
                    let birthDate = new Date(item.pat_birth * 1000);
                    pat_birth_input.innerText = `${birthDate.getFullYear()}-${birthDate.getMonth()+1}-${birthDate.getDate()}`;
                    let patRegistDate = new Date(item.pat_registTime * 1000);
                    pat_regist_input.innerText = `${patRegistDate.getFullYear()}-${patRegistDate.getMonth()+1}-${patRegistDate.getDate()}`;
                    
                    let registDate = new Date();
                    let registStr = `${registDate.getFullYear()}년`;
                    registStr += '            ';
                    registStr += `${registDate.getMonth()+1}월`;
                    registStr += '             ';
                    registStr += `${registDate.getDate()}일`;
                    regist_input.innerText = registStr;

                    sign_name_input.innerText = item.name;
                    sign_image_input.style.backgroundImage = `URL("${item.sign}")`;
                }

                // 두 번째 페이지 데이터 설정
                let item_Object2 = document.getElementById("print_item2");
                if (item_Object2) {
                    let sign_name_input2 = item_Object2.getElementsByClassName('sign_name_input2')[0];
                    let sign_image_input2 = item_Object2.getElementsByClassName('sign_image_input2')[0];
                    let sign_name_input3 = item_Object2.getElementsByClassName('sign_name_input3')[0];
                    let sign_image_input3 = item_Object2.getElementsByClassName('sign_image_input3')[0];
                    let sign_name_input4 = item_Object2.getElementsByClassName('sign_name_input4')[0];
                    let sign_image_input4 = item_Object2.getElementsByClassName('sign_image_input4')[0];

                    if (sign_name_input2 && sign_image_input2) {
                        sign_name_input2.innerText = item.name;
                        sign_name_input3.innerText = item.name;
                        sign_name_input4.innerText = item.name;
                        sign_image_input2.style.backgroundImage = `URL("${item.sign}")`;
                        sign_image_input3.style.backgroundImage = `URL("${item.sign}")`;
                        sign_image_input4.style.backgroundImage = `URL("${item.sign}")`;
                    }
                }
                
                // 데이터 설정이 완료되었음을 표시
                setIsDataReady(true);
            });
        });

        /*
        fetch(HTMLPAGE)
        .then((r) => r.text())
        .then(text => {
            setHtmltext1(text);
            setTimeout(() => {
                let item_Obect = document.getElementById("print_item1");

                console.log("item_Obect1 : ", item_Obect)
                let name_input = item_Obect.getElementsByClassName('name_input')[0];
                let jumin_input = item_Obect.getElementsByClassName('jumin_input')[0];
                let phone_input = item_Obect.getElementsByClassName('phone_input')[0];
                let address_input = item_Obect.getElementsByClassName('address_input')[0];
                let address_real_input = item_Obect.getElementsByClassName('address_real_input')[0];
                let pat_registnumber_input = item_Obect.getElementsByClassName('pat_registnumber_input')[0];
                let pat_name_input = item_Obect.getElementsByClassName('pat_name_input')[0];
                let pat_kind_input = item_Obect.getElementsByClassName('pat_kind_input')[0];
                let pat_color_input = item_Obect.getElementsByClassName('pat_color_input')[0];
                let pat_sex_input = item_Obect.getElementsByClassName('pat_sex_input')[0];
                let pat_neutering_input = item_Obect.getElementsByClassName('pat_neutering_input')[0];
                let pat_birth_input = item_Obect.getElementsByClassName('pat_birth_input')[0];
                let pat_regist_input = item_Obect.getElementsByClassName('pat_regist_input')[0];
                let regist_input = item_Obect.getElementsByClassName('regist_input')[0];
                let sign_name_input = item_Obect.getElementsByClassName('sign_name_input')[0];
                let sign_image_input = item_Obect.getElementsByClassName('sign_image_input')[0];
                
                console.log('item : ', item)

                // pat_registnumber_input .innerText = 등록 번호 입력;
                pat_registnumber_input.innerText = item.RFID?item.RFID:"";
                name_input.innerText = item.name;
                jumin_input.innerText = `${item.jumin} - ${item.jumin_next}`;
                phone_input.innerText = item.phone;

                if(item.addr == item.real_addr && item.addr_next == item.real_addr_next && item.addr_post == item.real_addr_post)
                {
                    address_input.innerText = `우편번호(${item.addr_post}) ${item.addr} ${item.addr_next}`;
                    address_real_input.innerText = "";
                }
                else
                {
                    address_input.innerText = `주소 - 우편번호(${item.addr_post}) ${item.addr} ${item.addr_next}`;
                    address_real_input.innerText = `현재 거주지 - 우편번호(${item.real_addr_post}) ${item.real_addr} ${item.real_addr_next}`;
                }

                pat_name_input.innerText = item.pat_name;
                pat_kind_input.innerText = item.pat_kind;
                pat_color_input.innerText = item.pat_color;
                pat_sex_input.innerText = item.pat_sex == "1"?'수':'암';
                pat_neutering_input.innerText = item.pat_neutering == "1"?'여':'부';
                let birthDate = new Date(item.pat_birth * 1000);
                pat_birth_input.innerText = `${birthDate.getFullYear()}-${birthDate.getMonth()+1}-${birthDate.getDate()}`;
                let patRegistDate = new Date(item.pat_registTime * 1000);
                pat_regist_input.innerText = `${patRegistDate.getFullYear()}-${patRegistDate.getMonth()+1}-${patRegistDate.getDate()}`;
                
                let registDate = new Date();
                let registStr = `${registDate.getFullYear()}년`;
                registStr += '            ';
                registStr += `${registDate.getMonth()+1}월`;
                registStr += '             ';
                registStr += `${registDate.getDate()}일`;
                regist_input.innerText = registStr;

                sign_name_input.innerText = item.name;
                sign_image_input.style.backgroundImage = `URL("${item.sign}")`;

            }, 1000)
        })
        

        fetch(HTMLPAGE_SECOND)
        .then((r) => r.text())
        .then(text => {
            setHtmltext2(text);
            setTimeout(() => {
                let item_Obect = document.getElementById("print_item2");

                let sign_name_input2 = item_Obect.getElementsByClassName('sign_name_input2')[0];
                let sign_image_input2 = item_Obect.getElementsByClassName('sign_image_input2')[0];
                let sign_name_input3 = item_Obect.getElementsByClassName('sign_name_input3')[0];
                let sign_image_input3 = item_Obect.getElementsByClassName('sign_image_input3')[0];
                let sign_name_input4 = item_Obect.getElementsByClassName('sign_name_input4')[0];
                let sign_image_input4 = item_Obect.getElementsByClassName('sign_image_input4')[0];
                sign_name_input2.innerText = item.name;
                sign_name_input3.innerText = item.name;
                sign_name_input4.innerText = item.name;
                sign_image_input2.style.backgroundImage = `URL("${item.sign}")`;
                sign_image_input3.style.backgroundImage = `URL("${item.sign}")`;
                sign_image_input4.style.backgroundImage = `URL("${item.sign}")`;

            }, 1000)
        })
        */
    }, [item]);

    const componentRef = useRef();

    //const handlePrint = useReactToPrint({content: () =>{return componentRef.current}, fonts:CUSTOM_FONTS});
    
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        fonts: CUSTOM_FONTS,
        onBeforeGetContent: () => {
            // 인쇄 전에 데이터와 이미지가 모두 준비되었는지 확인
            console.log('isDataReady : ', isDataReady)
            if (!isDataReady) {
                return new Promise((resolve) => {
                    const checkReady = setInterval(() => {
                        if (isDataReady) {
                            clearInterval(checkReady);
                            resolve();
                        }
                    }, 100);
                });
            }
            return Promise.resolve();
        },
        onPrintError: (error) => {
            console.error('Print error:', error);
            alert('인쇄 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        }
    });

    const iframePart1 = () => {
        return {
            __html: htmltext1,
        };
    };
    const iframePart2 = () => {
        return {
            __html: htmltext2,
        };
    };

    return (
        item?
        <div>
            {/* <ReactToPrint
                trigger={() => {
                    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                    // to the root node of the returned component as it will be overwritten.
                    return <a href="#">Print this out!</a>;
                }}
                content={() => componentRef}
            /> */}
            <button
                style={{
                    padding: '8px 16px',
                    fontSize: '14px',
                    backgroundColor: '#4a90e2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}
                onClick={handlePrint}
                disabled={!isDataReady}
            >
            {!isDataReady ? (
                <>
                    <div style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #ffffff',
                        borderTop: '2px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite'
                    }}></div>
                    준비중...
                </>
            ) : (
                '인쇄하기'
            )}</button>
            <div style={{height:100}}></div>
            <div ref={componentRef}>
                <div style={{pageBreakBefore:'always', position:'relative'}} id="print_item1">
                    
                    <div style={{position:'absolute', top:0, right:0, width: '100px', height: '100px'}}>
                        <object type="image/svg+xml" data={Logo} style={{width: '100px', height: 'auto'}} />
                    </div>
                    <ReportBlock
                        dangerouslySetInnerHTML={iframePart1()}
                    />
                </div>
                <div style={{pageBreakBefore:'always'}} id="print_item2">
                <ReportBlock
                    dangerouslySetInnerHTML={iframePart2()}
                />
                </div>
            </div>
        </div>:null
    );
};

export default React.memo(ReportView);
